import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import FlightSearchForm from "../../components/flight-search-form/FlightSearchForm.component";
import moment from "moment";
import "./Homepage.styles.css";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import PopupPage from "../popup-deals/Popuppage";
import axios from "axios";
import { theme_airline_url } from "../../utils/apiInfo";
import BestTour from "../../components/BestTours/BestTour";
import BestTourAu from "../../components/BestTours/BestTourAu";
import BestTourCa from "../../components/BestTours/BestTourCa";
import BestTourIn from "../../components/BestTours/BestTourIn";
import BestTourNz from "../../components/BestTours/BestTourNz";
import BestTourPh from "../../components/BestTours/BestTourPh";
import BestTourQa from "../../components/BestTours/BestTourQa";
import BestTourRp from "../../components/BestTours/BestTourRp";
import BestTourSg from "../../components/BestTours/BestTourSg";
import BestTourUAE from "../../components/BestTours/BestTourUAE";
import BestTourHk from "../../components/BestTours/BestTourHk";
import BestTourMy from "../../components/BestTours/BestTourMy";
import BestTourZa from "../../components/BestTours/BestTourZa";
import BestTourTh from "../../components/BestTours/BestTourTh";
import BestTourUk from "../../components/BestTours/BestTourUk";
import BestTourVn from "../../components/BestTours/BestTourVn";
import Aeroplane from "../../assets/images/new/down.png"
import smiling from "../../assets/images/new/smiling.jpg"

const HomePage = () => {
  const navigate = useNavigate();
  const [res, setRes] = useState();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleExpClick = (origin, dest) => {
    navigate({
      pathname: "/flights",
      search: `?search_t=${moment().unix()}&tripType=one-way&dep_loc=${origin}&dest_loc=${dest}&dep_dt=${moment().format(
        "YYYY-MM-DD"
      )}&ret_dt=null&fl_cl=ECONOMY&adt=1&chd=0`,
    });
  };

  const loadBestTour = () => {
    let urlname
    urlname = window.location.hostname.split('.')[0];
    if (urlname === 'localhost') {
      urlname = "au"
    } else {
      if (urlname === 'www') {
        urlname = "au"
      }
    }



    return (
      <>
        {urlname === 'Globalfarehub' ? <BestTour /> : ""}
        {urlname === 'au' ? <BestTourAu /> : ""}
        {urlname === 'ca' ? <BestTourCa /> : ""}
        {urlname === 'hk' ? <BestTourHk /> : ""}
        {urlname === 'in' ? <BestTourIn /> : ""}
        {urlname === 'id' ? <BestTourRp /> : ""}
        {urlname === 'my' ? <BestTourMy /> : ""}
        {urlname === 'nz' ? <BestTourNz /> : ""}
        {urlname === 'ph' ? <BestTourPh /> : ""}
        {urlname === 'qa' ? <BestTourQa /> : ""}
        {urlname === 'sg' ? <BestTourSg /> : ""}
        {urlname === 'sa' ? <BestTourZa /> : ""}
        {urlname === 'th' ? <BestTourTh /> : ""}
        {urlname === 'en' ? <BestTour /> : ""}
        {urlname === 'es' ? <BestTour /> : ""}
        {urlname === 'ae' ? <BestTourUAE /> : ""}
        {urlname === 'uk' ? <BestTourUk /> : ""}
        {urlname === 'vn' ? <BestTourVn /> : ""}
      </>
    )
  }
  // const [showPopup, setPopup] = useState('active')

  // function removePopup(){
  //   setPopup('')
  // }

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ],
  };

  const urlFull = window.location.href;
  useEffect(() => {
    axios
      .get(`${theme_airline_url}`, {
        params: {
          url: urlFull,
        },
      })
      .then((response) => {
        setRes(response.data.status);
      })
      .catch((error) => {
        console.error("API Error:", error);
      });
  }, [urlFull]);
  return (
    <React.Fragment>
      <Helmet>
        <title>Globalskyfare | Home </title>
      </Helmet>
      {res === "1" ? <PopupPage /> : ""}


      <section className="head-section">
        <div className="container">
          <div className="flex space-bw align-center">
            <div className="col-50 hero-text">
              <h1>Fly With Globalskyfare, Book Your Ticket Now</h1>
              <p>Seamless flight booking, affordable fares, unforgettable journeys. Book your flight tickets today with Globalskyfare.com.</p>
            </div>
            <div className="col-50 booking-form-main">
              <FlightSearchForm />
            </div>
          </div>
        </div>
      </section>

      <div className="add-section">
        <div className="container">
          <div className="flex space-bw">
            <div className="col-50">
              <div className="column promo-col cm-flex cm-flex-wrap">
                <div className="col-20"><span className="offer-tag">Offer</span><span className="curr__Icon">$</span></div>
                <div className="col-80">
                  <h5>Sign Up and Save Up to <span>$15 off</span></h5>
                  <p>Our fees on selected regions with a promo code!</p>
                  <div className="promo-code-form">
                    <form action="">
                      <input type="text" placeholder="Enter email address" />
                      <input type="submit" value="Get Promo Code!" />
                    </form>
                  </div>
                  <p><small>Expires May 31, 2023. Restrictions apply</small></p>
                </div>
              </div>
            </div>
            <div className="col-50">
              <div className="column cm-flex cm-flex-wrap">
                <div className="col-20"><span className="offer-tag">Call Now</span><span className="curr__Icon"><i className="fa-solid fa-phone" aria-hidden="true"></i></span></div>
                <div className="just-booking col-80">
                  <h5>Why to book with Travel Expert</h5>
                  <ul>
                    <li>Expert guidance by our Travel experts</li>
                    <li>Immediate booking confirmation</li>
                    <li>24 hour cancellation</li>
                    <li>Plans Flexible payment</li>
                  </ul>
                  <div className="booking-call"><a href="tel:(855) 738-1940" className="cm-btn">Call Now</a></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="gap">
        <div className="container">
          <div class="service-text text-center">
            <h2><span>Why Choose </span> Our Services</h2>
          </div>
          <div class="reasons flex space-bw">
            <div class="reason col-25">
              <i class="fa-solid fa-dollar-sign"></i>
              <h3>Incredible Offers</h3>
              <p>Get the best deals by obtaining special, unpublished fares.</p>
            </div>
            <div class="reason col-25">
              <i class="fa-solid fa-user"></i>
              <h3>Effortless Booking Experience</h3>
              <p>A user-friendly interface that makes reservations quick and stress-free</p>
            </div>
            <div class="reason col-25">
              <i class="fa-solid fa-clock"></i>
              <h3>Around-the-Clock Help</h3>
              <p>Our committed staff offers client assistance around the clock</p>
            </div>
            <div class="reason col-25">
              <i class="fa-solid fa-plane"></i>
              <h3>Credible Partners</h3>
              <p>Partnered with leading airlines to ensure reliable flight services around the globe</p>
            </div>
          </div>
        </div>
      </section>

      <section class="gap" style={{ backgroundColor: "#eee" }}>
        <div class="container">
          <div class="service-text text-center">
            <h2>Discover Our <span>Best Selections</span></h2>
          </div>
          <div class="packages flex space-bw">
            <div class="pack-detail col-25">
              <div class="package-image">
                <img src={require("../../assets/images/new/cape.jpg")} alt="" /></div>
              <div class="package-text-top">
                <h3>Cape Town, South Africa</h3>
                <p>Where adventure thrives in vibrant landscapes</p>
                <button onClick={(e) => handleExpClick("CPT", "NAP")}>Start exploring</button>
              </div>
            </div>
            <div class="pack-detail col-25">
              <div class="package-image">
                <img src={require("../../assets/images/new/japan.jpg")} alt="" />
              </div>
              <div class="package-text-top">
                <h3>Kyoto, Japan</h3>
                <p>Witness Japan's timeless beauty firsthand</p>
                <button onClick={(e) => handleExpClick("UKY", "OSA")}>Start exploring</button>
              </div>
            </div>
            <div class="pack-detail col-25">
              <div class="package-image">
                <img src={require("../../assets/images/new/paris.jpg")} alt="" />
              </div>
              <div class="package-text-top">
                <h3>Paris, France</h3>
                <p>Experience the enchanting charm of Paris</p>
                <button onClick={(e) => handleExpClick("PAR", "POS")}>Start exploring</button>
              </div>
            </div>
            <div class="pack-detail col-25">
              <div class="package-image">
                <img src={require("../../assets/images/new/hawai.jpg")} alt="" />
              </div>
              <div class="package-text-top">
                <h3>Hawaii, USA</h3>
                <p>Hawaii: Your path to paradise awaits</p>
                <button onClick={(e) => handleExpClick("HNL", "NYC")}>Start exploring</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="gap review-slider">
        <div className="container">
          <div class="service-text text-center">
            <h2>Customer Feedback</h2>
          </div>
          <div className="testimonials-slider">
            <Slider {...settings}>
              <div className="tst-slide">
                <div class="quotes">
                  <i class="fa-solid fa-quote-left" aria-hidden="true"></i>
                </div>
                <p>The booking procedure was smooth and efficient. The website is easy to navigate, and the customer care crew was quite helpful when I had a query. I was able to locate excellent rates and book my travel fast</p>
                <h3>Tom Cruise</h3>
                <div class="star">
                  <i class="fa-solid fa-star" aria-hidden="true"></i>
                  <i class="fa-solid fa-star" aria-hidden="true"></i>
                  <i class="fa-solid fa-star" aria-hidden="true"></i>
                  <i class="fa-solid fa-star" aria-hidden="true"></i>
                  <i class="fa-solid fa-star" aria-hidden="true"></i>
                </div>
              </div>
              <div className="tst-slide">
                <div class="quotes">
                  <i class="fa-solid fa-quote-left" aria-hidden="true"></i>
                </div>
                <p>I was impressed with this website's wide range of airlines and destinations. I found the perfect flight for my trip, and the booking process was straightforward. I'll definitely be using this website again for future travel plans</p>
                <h3>Carl Johnson</h3>
                <div class="star">
                  <i class="fa-solid fa-star" aria-hidden="true"></i>
                  <i class="fa-solid fa-star" aria-hidden="true"></i>
                  <i class="fa-solid fa-star" aria-hidden="true"></i>
                  <i class="fa-solid fa-star" aria-hidden="true"></i>
                  <i class="fa-solid fa-star-half"></i>
                </div>
              </div>
              <div className="tst-slide">
                <div class="quotes">
                  <i class="fa-solid fa-quote-left" aria-hidden="true"></i>
                </div>
                <p>I've used this website to book several flights, and I've always been happy with the service. The website is easy to use, and I've always been able to find great deals on flights</p>
                <h3>James Bond</h3>
                <div class="star">
                  <i class="fa-solid fa-star" aria-hidden="true"></i>
                  <i class="fa-solid fa-star" aria-hidden="true"></i>
                  <i class="fa-solid fa-star" aria-hidden="true"></i>
                  <i class="fa-solid fa-star" aria-hidden="true"></i>
                  <i class="fa-solid fa-star" aria-hidden="true"></i>
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </section>

    </React.Fragment >
  );
};

export default HomePage;
